import ProductRelated from "./product-related";
export default ProductRelated;